<app-modal #modal title="Update Firmware Requests History" [hasConfirmButton]="false" size="xl">
	<div class='request-history'>
		<div *ngIf="modalSiteId != battviewMobileSiteID">
			<div class='tcenter body-bg-color boxs3'><strong>{{'g.chargers' | translate}}</strong></div>
			<table class='table table-striped'>
				<thead>
					<tr>
						<th>{{'g.version' | translate}}</th>
						<th>{{'g.user' | translate}}</th>
						<th>{{'g.date' | translate}}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let charger of requestsLog.charger">
						<td>{{charger.firmwareversion}}</td>
						<td>{{usersInfo[charger.userid] || '-'}}</td>
						<td>{{charger.daterequested | date:'MM/dd/yyyy hh:mm:ss a'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div>
			<div class='tcenter body-bg-color boxs3'><strong>{{'g.battviews' | translate}}</strong></div>
			<table class='table table-striped'>
				<thead>
					<tr>
						<th>{{'g.version' | translate}}</th>
						<th>{{'g.user' | translate}}</th>
						<th>{{'g.date' | translate}}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let battview of requestsLog.battview">
						<td>{{battview.firmwareversion}}</td>
						<td>{{usersInfo[battview.userid] || '-'}}</td>
						<td>{{battview.daterequested | date:'MM/dd/yyyy hh:mm:ss a'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div>
			<div class='tcenter body-bg-color boxs3'><strong>{{'g.wifi' | translate}}</strong></div>
			<table class='table table-striped'>
				<thead>
					<tr>
						<th>{{'g.version' | translate}}</th>
						<th>{{'g.user' | translate}}</th>
						<th>{{'g.date' | translate}}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let wifi of requestsLog.wifi">
						<td>{{wifi.firmwareversion}}</td>
						<td>{{usersInfo[wifi.userid] || '-'}}</td>
						<td>{{wifi.daterequested | date:'MM/dd/yyyy hh:mm:ss a'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div *ngIf="modalSiteId != battviewMobileSiteID">
			<div class='tcenter body-bg-color boxs3'><strong>{{'g.bms' | translate}}</strong></div>
			<table class='table table-striped'>
				<thead>
					<tr>
						<th>{{'g.id' | translate}}</th>
						<th>{{'g.version' | translate}}</th>
						<th>{{'g.user' | translate}}</th>
						<th>{{'g.date' | translate}}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let bms of requestsLog.bms">
						<td>{{bmsTypesObj[bms.firmwaretype].text}}</td>
						<td>{{bms.firmwareversion}}</td>
						<td>{{usersInfo[bms.userid] || '-'}}</td>
						<td>{{bms.daterequested | date:'MM/dd/yyyy hh:mm:ss a'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div *ngIf="modalSiteId != battviewMobileSiteID">
			<div class='tcenter body-bg-color boxs3'><strong>{{'g.pms' | translate}}</strong></div>
			<table class='table table-striped'>
				<thead>
					<tr>
						<th>{{'g.version' | translate}}</th>
						<th>{{'g.user' | translate}}</th>
						<th>{{'g.date' | translate}}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let pm of requestsLog.pm">
						<td>{{pm.firmwareversion}}</td>
						<td>{{usersInfo[pm.userid] || '-'}}</td>
						<td>{{pm.daterequested | date:'MM/dd/yyyy hh:mm:ss a'}}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</app-modal> 
<div class="row">
	<div class="panel panel-default">
		<div class="panel-body">
			<div class="col-md-12 mb20">
				<fieldset class="fieldset-display">
					<legend style="font-size:18px">{{'site.push_firmware_for_all_sites' | translate}}</legend>
					<div>
						<span class="text-style">{{'g.chargers' | translate}}:</span>
						<div>
							<select class="form-control inline-form-control margin-right" [(ngModel)]="allChargersFirmwareVersion">
								<option *ngFor="let version of firmwareVersions.charger" [value]="version">{{version}}</option>
							</select>
							<button class="btn btn-default" (click)="pushFirmwareUpdate('charger', {id: 0, 'chargerFirmwareVersion': allChargersFirmwareVersion})" [disabled]="!allChargersFirmwareVersion">{{'site.push_firmware' | translate}}</button>
						</div>
					</div>
					<div>
						<span class="text-style">{{'g.battviews' | translate}}:</span>
						<div>
							<select class="form-control inline-form-control margin-right" [(ngModel)]="allBattviewsFirmwareVersion">
								<option *ngFor="let version of firmwareVersions.battview" [value]="version">{{version}}</option>
							</select>
							<button class="btn btn-default" (click)="pushFirmwareUpdate('battview', {id: 0, 'battviewFirmwareVersion': allBattviewsFirmwareVersion})" [disabled]="!allBattviewsFirmwareVersion">{{'site.push_firmware' | translate}}</button>
						</div>
					</div>
					<div>
						<span class="text-style">{{'g.wifi' | translate}}:</span>
						<div>
							<select class="form-control inline-form-control margin-right" [(ngModel)]="allWifiFirmwareVersion">
								<option *ngFor="let version of firmwareVersions.wifi" [value]="version">{{version}}</option>
							</select>
							<button class="btn btn-info" (click)="pushFirmwareUpdate('wifi', {id: 0, 'wifiFirmwareVersion': allWifiFirmwareVersion})" [disabled]="!allWifiFirmwareVersion">{{'site.push_wifi_firmware' | translate}}</button>
						</div>
					</div>
					<div *ngIf="firmwareVersions.bms">
						<span class="text-style">{{'g.bms' | translate}}:</span>
						<div>
							<select class="form-control inline-form-control" [(ngModel)]="allBmsFirmwareType" (ngModelChange)="allBmsFirmwareVersion = null">
								<option *ngFor="let type of bmsTypes" [ngValue]="type.id">{{type.text}}</option>
							</select>
							<select class="form-control inline-form-control margin-top-xs margin-right" [(ngModel)]="allBmsFirmwareVersion">
								<option *ngFor="let version of firmwareVersions.bms[allBmsFirmwareType]" [value]="version">{{version}}</option>
							</select>
							<button class="btn btn-warning" (click)="pushFirmwareUpdate('bms', {id: 0, 'bmsFirmwareVersion': allBmsFirmwareVersion, 'bmsFirmwareType': allBmsFirmwareType})" [disabled]="!allBmsFirmwareVersion || !allBmsFirmwareType">{{'site.push_bms_firmware' | translate}}</button>
						</div>
					</div>
					<div>
						<span class="text-style">{{'g.power_module_Q3' | translate}}:</span>
						<div>
							<select class="form-control inline-form-control margin-top-xs margin-right" [(ngModel)]="allPMFirmwareVersion">
								<option *ngFor="let version of firmwareVersions.pm" [value]="version">{{version}}</option>
							</select>
							<!-- <app-ng-dropdown [options]="firmwareVersions.pm"></app-ng-dropdown> -->
							<button class="btn btn-default" [disabled]="!allPMFirmwareVersion">{{'site.pm_firmware' | translate}}</button>
						</div>
					</div>
				</fieldset>
			</div>
		</div>
	</div>
	<div class="panel panel-default">
		<div class="panel-body">
			<input [(ngModel)]="customerNameFilter" placeholder="{{'site.search_filter_customers' | translate}}" class="form-control"/>
			<br/>
			<ul class="insm sidebar-nav">
				<li *ngFor="let customer of connectivity | filter:customerNameFilter: 'name'">
					<a href="javascript:" (click)="toggleExpanded(customer);">
						<span class="glyphicon" [ngClass]="{'glyphicon-plus-sign': !customer.expanded, 'glyphicon-minus-sign': customer.expanded}"></span>
						{{customer.name}}
					</a>
					<ul *ngIf="customer.expanded" class="sidebar-nav">
						<li>
							<table class="table table-striped">
								<thead>
									<tr>
										<th>{{'g.site' | translate}}</th>
										<th>{{'site.last_connect_time' | translate}}</th>
										<th [innerHTML]="'site.devices_got_the_last_update_request' | translate | safe: 'html'"></th>
										<th>{{'device.update_chargers' | translate}}</th>
										<th>{{'device.update_battviews' | translate}}</th>
										<th>Update WiFi</th>
										<th>Update BMS</th>
										<th>Update PMs</th>
										<th>Update PolarLink</th>
										<th [innerHTML]="'site.show_requests_history' | translate | safe: 'html'"></th>
										<th *ngIf="userService.hasAccessFunction('control_site_live_socket')" [innerHTML]="'device.chargers_live_socket_enable' | translate | safe: 'html'"></th>
										<th *ngIf="userService.hasAccessFunction('control_site_live_socket')" [innerHTML]="'device.battviews_live_socket_enable' | translate | safe: 'html'"></th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let site of customer.sites | values">
										<td>{{site.name}}</td>
										<td>{{site.lastconnecttime | date:'MM/dd/yyyy hh:mm:ss a'}}<br/>&nbsp;<b>{{site.timeDiff.diff}}</b> {{site.timeDiff.unit}}s ago</td>
										<td class="text-underline pointer" routerLink="/devices-connectivity" [queryParams]="{'customerID': customer.id, 'siteID': site.id}">
											<span *ngIf="site.id != battviewMobileSiteID">{{site.firmwareUpdateCounts.charger.updated}}/{{site.firmwareUpdateCounts.charger.total}} {{'g.chargers' | translate}} - </span>{{site.firmwareUpdateCounts.battview.updated}}/{{site.firmwareUpdateCounts.battview.total}} {{'g.battviews' | translate}}<br/><br/>
											<strong class="text-underline">{{'g.wifi' | translate}}:</strong><br/>
											<span *ngIf="site.id != battviewMobileSiteID">{{site.wifiFirmwareUpdate.charger}}/{{site.firmwareUpdateCounts.charger.total}} {{'g.chargers' | translate}} - </span>{{site.wifiFirmwareUpdate.battview}}/{{site.firmwareUpdateCounts.battview.total}} {{'g.battviews' | translate}}<br/><br/>
											<strong class="text-underline">{{'g.bms' | translate}}:</strong><br/>
											<span *ngIf="site.id != battviewMobileSiteID">{{site.bmsFirmwareUpdates}}/{{site.firmwareUpdateCounts.charger.total}} {{'g.chargers' | translate}}</span>
										</td>
										<td class="" *ngIf="site.id != battviewMobileSiteID"> <!-- Chargers  -->
											<div class="flex">
												<select class="form-control margin-right margin-auto" [(ngModel)]="site.chargerFirmwareVersion">
													<option *ngFor="let version of filterVersions(firmwareVersions.charger, site.chargersfirmwareversion)" [value]="version">{{version}}</option>
												</select>
												<button class="btn btn-default" (click)="pushFirmwareUpdate('charger', site)" [disabled]="!site.chargerFirmwareVersion">{{'device.push_fw' | translate}}</button> <br/>
											</div>
										</td>

										<td> <!-- Battview  -->
											<div class="flex">
												<select class="form-control margin-auto" [(ngModel)]="site.battviewFirmwareVersion">
													<option *ngFor="let version of filterVersions(firmwareVersions.battview, site.battviewsfirmwareversion)" [value]="version">{{version}}</option>
												</select>
												<button class="btn btn-default" (click)="pushFirmwareUpdate('battview', site)" [disabled]="!site.battviewFirmwareVersion">{{'device.push_fw' | translate}}</button>
											</div>
										</td>
										<td><!-- Wifi  -->
											<div class="flex">
												<select class="form-control margin-auto" [(ngModel)]="site.wifiFirmwareVersion"> <!-- WiFi  -->
													<option *ngFor="let version of filterVersions(firmwareVersions.wifi, site.wififirmwareversion)" [value]="version">{{version}}</option>
												</select>
												<button class="btn btn-info" (click)="pushFirmwareUpdate('wifi', site)" [disabled]="!site.wifiFirmwareVersion">{{'device.push_wifi_fw' | translate}}</button>
											</div>
										</td>
										<td><!-- BMS  -->
											<div class="flex-nowrap">
												<select class="form-control margin-right margin-auto" [(ngModel)]="site.bmsFirmwareType" (ngModelChange)="site.bmsFirmwareVersion = null">
													<option *ngFor="let type of bmsTypes" [ngValue]="type.id">{{type.text}}</option>
												</select>
												<select class="form-control margin-auto" [(ngModel)]="site.bmsFirmwareVersion">
													<option *ngFor="let version of filterVersions(firmwareVersions.bms, site, 'bms')" [value]="version">{{version}}</option>
												</select>
											</div>
											<button class="btn btn-warning" (click)="pushFirmwareUpdate('bms', site)" [disabled]="!site.bmsFirmwareType || !site.bmsFirmwareVersion">{{'device.push_bms_fw' | translate}}</button>
										</td>
										<td> <!-- PMs  -->
											<div class="flex">
												<select class="form-control margin-auto" [(ngModel)]="site.pmFirmwareVersion">
													<option *ngFor="let version of filterVersions(firmwareVersions.pm, site.pm_firmwareversion)" [value]="version">{{version}}</option>
												</select>
												<button class="btn btn-default" (click)="pushFirmwareUpdate('pm', site)" [disabled]="!site.pmFirmwareVersion">{{'device.push_pm_firmware' | translate}}</button>
											</div>
										</td>
										<!-- Polar Link  -->
										<td> 
											<div class="flex">
												<select class="form-control margin-auto" [(ngModel)]="site.polarlinkFirmwareVersion">
													<option *ngFor="let version of filterVersions(firmwareVersions.polarlink, site.polarLink_Firmwareversion)" [value]="version">{{version}}</option>
												</select>
												<button class="btn btn-default" (click)="pushFirmwareUpdate('polarlink', site)" [disabled]="!site.polarlinkFirmwareVersion">{{'device.push_polarlink_firmware' | translate}}</button>
											</div>
										</td>
										<td>
											<span class="pointer htl glyphicon glyphicon-list-alt" (click)="showFirmwareRequestsLog(site.id)"></span>
										</td>
										<td *ngIf="userService.hasAccessFunction('control_site_live_socket')">
											<input type="checkbox" class="form-control" [ngModel]="site.charger_live_socket_enable" (ngModelChange)="editSiteLiveSocket(site.id, 'charger', $event)"/>
										</td>
										<td *ngIf="userService.hasAccessFunction('control_site_live_socket')">
											<input type="checkbox" class="form-control" [ngModel]="site.battview_live_socket_enable" (ngModelChange)="editSiteLiveSocket(site.id, 'battview', $event)"/>
										</td>
									</tr>
								</tbody>
							</table>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</div>